export default "__VITE_ASSET__71ab99fd__"